import { TableV2Column } from 'components/Table/TableV2';
import { SearchCalendarMeetingsItem } from '../types/SearchCalendarMeetingsItem';
import { Chip, Link, Stack, Tooltip } from '@mui/material';
import { Error } from '@mui/icons-material';
import { Paths } from 'services/navigation/paths';
import { getPanelTypeLabel } from '../utils/getPanelTypeLabel';
import { getTemplateEditBlockedReason } from '../utils/getTemplateEditBlockedReason';
import { isRoundRobinMethod } from '../utils/isRoundRobinMethod';

export const calendarMeetingTemplateColumns: TableV2Column<SearchCalendarMeetingsItem>[] =
  [
    {
      name: 'Template',
      cell: (row) => (
        <Link href={`${Paths.CALENDAR_MEETING_TEMPLATE_PREVIEW}/${row.id}`}>
          {row.title}
        </Link>
      ),
      grow: 2
    },
    {
      name: 'Organiser',
      cell: (row) => {
        // Round robin picks the interviewer when the candidate books.
        if (isRoundRobinMethod(row.availabilityMethod)) {
          return 'Assigned at booking';
        }

        const blockedReason = getTemplateEditBlockedReason(row);
        const name =
          row.organizerUserCalendar?.name ??
          (blockedReason ? 'No organiser' : '-');

        if (!blockedReason) {
          return name;
        }

        // describeChild keeps our accessible name, so focus reaches the reason too.
        return (
          <Tooltip title={blockedReason} describeChild>
            <Stack
              component="span"
              direction="row"
              alignItems="center"
              gap={0.5}
              role="note"
              tabIndex={0}
              aria-label={`${name}. ${blockedReason}`}
              data-testid="edit-blocked-owner"
            >
              <Error
                color="error"
                sx={{ fontSize: '16px' }}
                aria-hidden="true"
              />
              {name}
            </Stack>
          </Tooltip>
        );
      },
      grow: 2
    },
    {
      name: 'Interview panel',
      cell: (row) => (
        <Chip label={getPanelTypeLabel(row.availabilityMethod)} size="small" />
      ),
      grow: 2
    },
    {
      name: 'Duration',
      selector: (row) => row.durationMinutes + ' minutes',
      grow: 1
    }
  ];
